import Modal from "components/atoms/Modal/modal";
import { Button, Typography } from "@atoms";
import {
  ChapterTitle,
  Divider,
  Footer,
  Header, HeaderTitle,
  IconWrapper,
  LoaderContainer, RollbackButton,
  Wrapper
} from "./editor.styles";
import { CheckOutlined } from "@ant-design/icons";
import TitleInput from "./titleInput";
import { useChapterEditorDataContext } from "contexts/ChapterEditorContext";
import Paragraphs from "./Paragraphs/paragraphs";
import { useWallDataContext } from "contexts/WallContext";
import  { ReactComponent as LoadArrowsIcon } from "@assets/icons/loadArrows.svg";
import  { ReactComponent as RollbackIcon } from "@assets/icons/rollback.svg";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "hooks";
import React, { useState } from "react";
import ChapterDates from "./ChapterDates/chapterDates";
import { createDraftFromChapterApi } from "../../../../api/chapters";
import { deleteDraftChapter } from "../../../../api/draftChapters";
import { Loader, Loading } from "../../../../globalStyles";

export default function Editor({isOpen, onClose}: {isOpen: boolean, onClose: () => void}) {
  const { t } = useTranslation();
  const isMobile = useIsMobile(767);
  const { onDraftChapterPublish, updateDraftUuid } = useWallDataContext();
  const { draftChapter, updateDraftChapter, isSaving } = useChapterEditorDataContext();
  const [isRestoring, setIsRestoring] = useState(false);

  const onPublish = async () => {
    if (!draftChapter.uuid || !draftChapter.title) return;
    try {
      onDraftChapterPublish(draftChapter.uuid);
      onClose();
    } catch (e) {}
  }

  const onRestore = async () => {
    if (!draftChapter.uuid || !draftChapter.title) return;
    setIsRestoring(true);
    try {
      const chapterUuid = draftChapter.original_chapter || "";
      await deleteDraftChapter(draftChapter.uuid);
      const res = await createDraftFromChapterApi(chapterUuid);
      updateDraftChapter({...res});

      updateDraftUuid(chapterUuid, res.uuid || null);
    } catch (e) {
      //
    } finally {
      setTimeout(() => {
        setIsRestoring(false);
      }, 150);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Wrapper>
        <Loader style={{borderRadius: "8px"}} loading={isRestoring}>
          <Loading/>
        </Loader>
        <Header>
          <HeaderTitle><Typography>{t('wall.addChapter')}</Typography></HeaderTitle>
          <ChapterDates />
        </Header>
        <ChapterTitle>
          <TitleInput
            value={draftChapter.title}
            onKeyDown={(e) => {
              if (e.currentTarget.value.length === 0 && !/^[a-zA-Z0-9\u0400-\u04FF]$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            onChange={(e) => updateDraftChapter({title: e.currentTarget.value})}
            placeholder={t('wall.enterTitle')}
            required
          />
        </ChapterTitle>
        <Divider />
        <Paragraphs />
        <Divider />
        <Footer>
          {draftChapter.original_chapter && !isMobile && (
            <RollbackButton disabled={isSaving} onClick={onRestore}>
              <RollbackIcon />{t('wall.cancelChanges')}
            </RollbackButton>
          )}

          {!isMobile && <div style={{flex: 1}} />}
          {!isMobile && (
            <LoaderContainer>
              {isSaving && (
                <IconWrapper
                  layout
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
                >
                  <LoadArrowsIcon />
                </IconWrapper>
              )}
              {!isSaving && <CheckOutlined />}
              <span>{isSaving ? t("wall.saving") : t("wall.saved")}</span>
            </LoaderContainer>
          )}

          <Button fullWidth={isMobile} disabled={isSaving} variant="outlined" onClick={onClose}>{t('wall.close')}</Button>
          <Button fullWidth={isMobile} disabled={isSaving} onClick={onPublish}>{t('wall.publish')}</Button>
        </Footer>
      </Wrapper>
    </Modal>
  );
};
